import { createClient } from "./createClient";
import { environment } from "../../environments/environment";

export const client = createClient(
  environment.graphqlApiUrl,
  originToWsUrl(window.location.origin) + environment.wsApiUrl
);

window["__APOLLO_CLIENT__"] = client;

function originToWsUrl(origin: string) {
  // should be wss for https
  if (origin.startsWith("https")) {
    return origin.replace(/^https/, "wss");
  } else {
    return origin.replace(/^http/, "ws");
  }
}
